// Tiny analytics helper that fires a single event to BOTH GA4 (window.gtag)
// and PostHog (window.posthog) when either / both are present. Safe no-op if
// neither has loaded.
//
// Usage:
//   import { track } from "@/lib/analytics";
//   track("enquiry_submit", { role: "Contractor", need: "Hardware Supply" });

export const track = (event, params = {}) => {
  if (!event) return;
  try {
    if (typeof window === "undefined") return;
    // GA4 — only fires if gtag is initialised (REACT_APP_GA_ID present)
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
    // PostHog — already loaded via public/index.html
    if (window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, params);
    }
  } catch (e) {
    // never let analytics break the UI
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("analytics track failed", e);
    }
  }
};

// Convenience wrappers for the most-used conversion events on this site
export const trackEnquirySubmit = (payload = {}) =>
  track("enquiry_submit", payload);

export const trackWhatsAppClick = (location = "unknown") =>
  track("whatsapp_click", { location });

export const trackPhoneClick = (location = "unknown") =>
  track("phone_click", { location });

export const trackQuoteCTA = (location = "unknown") =>
  track("quote_cta_click", { location });
